module.exports = __webpack_public_path__ + "img/usage.ff58ae52.svg";